var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"back"},[_c('b-btn',{staticClass:"foreground-blue pl-0",attrs:{"variant":"link","squared":""},on:{"click":_vm.goBack}},[_c('b-icon',{attrs:{"icon":"arrow-left"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }